"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = void 0;
var FilesActions = require("@caddigital/sok-reducers/lib/actions/files");
var FilesConversionActions = require("@caddigital/sok-reducers/lib/actions/files/automaticFileConversion");
var ToastActions = require("@caddigital/sok-reducers/lib/actions/toast");
var translation_1 = require("@caddigital/sok-ui/lib/utils/translation");
var automaticFileConversion_1 = require("@caddigital/sok-reducers/lib/reducers/files/automaticFileConversion");
var mapDispatchToProps = function (dispatch) { return ({
    setFilePreview: function (uuid, revisionUuid, status) {
        return dispatch(FilesActions.PreviewActions.generatePreviewSuccess(uuid, revisionUuid, status));
    },
    setConversionErrorToast: function (fileName) {
        var message = (0, translation_1.getLocalization)('filesPreview/preview/ifc/automaticConversion/error');
        var title = fileName;
        dispatch(ToastActions.addNewToast(title, message, 'FAILURE'));
    },
    clearAutomaticConversionStatus: function () {
        dispatch(FilesConversionActions.updateRevisionConversionStatus(automaticFileConversion_1.initialState.automaticFileConversion));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
